import { AppointmentPractitioner } from '@dreryk/egabinet-appointment-frontend-api';

import { Text, TextSeparator, TextSeparatorType, TextView } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { translationKeys } from '../translations';

import { getPractitionerNameAndTitle, getPractitionerSpecialtyNames } from './AppointmentPractitionerTextView.utils';

type AppointmentPractitionerTextViewProps = Readonly<{ practitioner: AppointmentPractitioner }>;

export const AppointmentPractitionerTextView = (props: AppointmentPractitionerTextViewProps): JSX.Element => {
   const specializations = getPractitionerSpecialtyNames(props.practitioner);

   return (
      <TextView testId={'practitioner'} label={translationKeys.practitioner}>
         <TextSeparator separator={TextSeparatorType.COMMA_SPACE}>
            <Text testId={'name'}>{getPractitionerNameAndTitle(props.practitioner)}</Text>

            {specializations.length ? (
               <Text testId={'specializations'}>
                  <TextSeparator separator={TextSeparatorType.COLON_SPACE}>
                     <Translate>{translationKeys.specializations}</Translate>
                     <span>{specializations}</span>
                  </TextSeparator>
               </Text>
            ) : null}
         </TextSeparator>
      </TextView>
   );
};
